
import { get, post } from '../utils/http'

export const fetchWeeks = () => (get('FETCH_NEWSLETTER_WEEKS', '/admin/newsletter/weeks'));

export const fetchNewsletters = (week) => (get('FETCH_NEWSLETTERS', `/newsletters/period/${week}/databases`, 'payload', { week }))

export const generateNewsletter = (id) => (post('GENERATE_NEWSLETTER', `/admin/newsletter/${id}/generate`))

export const changeWeek = (week) => ({ type: 'CHANGE_NEWSLETTER_WEEK', payload: week })

export const changeNewsletter = (newsletterId, database, published) => ({ type: 'CHANGE_NEWSLETTER', payload: { newsletterId, database, published }});

export const loadEmails = (id) => (get('NEWSLETTER_FETCH_EMAILS', `/admin/newsletters/${id}/emails`));

export const toggleEmailDialog = (show) => ({ type: 'NEWSLETTER_TOGGLE_EMAIL_DIALOG', payload: show })

export const toggleSendDialog = (show) => ({ type: 'NEWSLETTER_TOGGLE_SEND_DIALOG', payload: show })

export const fetchStats = (id) => (get('NEWSLETTER_FETCH_STATS', `/newsletters/${id}/stats`));

export const edit = (id) => (get('NEWSLETTER_EDIT', `/newsletters/${id}/edit`));

export const editAttr = (value, attr) => ({ type: 'NEWSLETTER_EDIT_ATTR', payload: { value, attr } })

export const editGenerateAttr = (attr, value) => ({ type: 'NEWSLETTER_EDIT_GENERATE_ATTR', payload: { value, attr } })

export const createNew = () => ({ type: 'NEWSLETTER_CREATE' })

export const hideNewDialog = () => ({ type: 'NEWSLETTER_CREATE_HIDE' })

export const createNewsletters = (year, week, databases, isLegalLetter, sendDate, includeFromDate) => {

  let form = new FormData();
  form.append('year', year);
  form.append('week', week);
  form.append('databases', databases);
  form.append('isLegalLetter', isLegalLetter? 'true' : 'false');
  form.append('sendDate', sendDate);
  form.append('includeFromDate', includeFromDate);

  return post('NEWSLETTER_CREATE_SUBMIT', `/admin/newsletter/create`, form);

}

export const generate = (params) => {

  let form = new FormData();
  form.append('id', params.id);
  form.append('type', params.type);
  form.append('originalFilename', params.originalFilename);
  form.append('chapter', params.chapter);
  form.append('paragraph', params.paragraph);
  form.append('additional', params.additional);
  form.append('change', params.change);
  form.append('title', params.title);
  form.append('url', params.url)
  form.append('includeFromDate', params.includeFromDate);

  return post('FETCH_NEWSLETTER_GENERATE', `/admin/newsletter/generate`, form);
}

export const save = (newsletter) => {

  let form = new FormData();
  form.append('id', newsletter.id);
  form.append('year', newsletter.year);
  form.append('week', newsletter.week);
  form.append('title', newsletter.title);
  form.append('titleInContent', newsletter.titleInContent);
  form.append('database', newsletter.database);
  form.append('content', newsletter.content);
  form.append('published', newsletter.published);
  form.append('sendDate', newsletter.sendDate);

  return post('NEWSLETTER_SAVE', `/admin/newsletter/update`, form);
}

export const deleteNewsletter = (id) => {

  let form = new FormData();
  form.append('id', id);

  return post('NEWSLETTER_DELETE', `/admin/newsletter/delete`, form);
}

export const sendNewsletter = (id, databases, sendQ, sendJonas) => {

  let form = new FormData();
  form.append('id', id);
  form.append('databases', databases.join(''));
  form.append('sendQ', sendQ);
  form.append('sendJonas', sendJonas);

  return post('NEWSLETTER_SEND', `/admin/newsletter/send`, form);

}


// WEBPACK FOOTER //
// ./src/newsletter/newsletterActions.js